import * as products from './list'

export const allProducts = Object.values(products).sort((previous, current) =>
    previous.name.localeCompare(current.name),
)
